import React from 'react'
import Footer from '../Footer'
import EduTwo from '../EduTwo'

function ImgthsOne() {
    window.scrollTo(0,0);
    return (
        <div>
            <EduTwo/>
            <Footer/>
        </div>
    )
}

export default ImgthsOne
